import React from "react";
import { Alert, AlertTitle, Box, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import Panel from "../../components/Panel";
import { LabRecord } from "../../interfaces/Lab";
import ReferrerCreateSelect from "../Referrers/ReferrerCreateSelect";
import useCurrentResourceCentre from "../../hooks/useCurrentResourceCentre";
import { Type, updateLabTestsRecordReferrers } from "../../actions/labTest";
import useGetOnGoing from "../../hooks/useGetOnGoing";

interface Props {
  labObj: LabRecord;
  onClose: () => void;
}

const LabRecordReferrerUpdatePanel = ({ labObj, onClose }: Props): JSX.Element => {
  const labObjRef = React.useRef(labObj);
  const currentRc = useCurrentResourceCentre();
  const [referrer, setReferrer] = React.useState<{ name: string; id: number } | null>({
    name: labObj.referrers,
    id: labObj.referrerId
  });
  const [extraReferrer, setExtraReferrer] = React.useState<{ name: string; id: number } | null>({
    name: labObj.extraReferrer?.name || "",
    id: labObj.extraReferrer?.id || null
  });
  const showExtraReferrer = currentRc?.labSettings?.enableExtraReferrer;
  const isLoading = useGetOnGoing(Type.UPDATE_LAB_TEST_RECORD_REFERRERS);

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (labObjRef.current?.id !== labObj?.id) {
      onClose();
    }
  }, [labObj]);

  return (
    <Panel
      title="Update Referrer"
      onClose={onClose}
      footer={
        <Box
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            flexGrow: 1
          }}
        >
          <Box display="flex" gap={2}>
            <Button onClick={onClose}>Cancel</Button>
            <Button
              loading={isLoading}
              variant="contained"
              onClick={async () => {
                await dispatch(
                  updateLabTestsRecordReferrers(labObj.id, {
                    referrer: { id: referrer?.id, name: referrer?.referrer || "" },
                    ...(showExtraReferrer
                      ? {
                          extraReferrer: { id: extraReferrer?.id, name: extraReferrer?.name || "" }
                        }
                      : {})
                  })
                );
                onClose();
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      }
    >
      <Alert severity="info">
        <AlertTitle>Info</AlertTitle>implement referrer edit after lab test order creation Updating
        referrer after creating lab will not update anything on bill/commission.
      </Alert>
      <Box mt={2}>
        <ReferrerCreateSelect
          isClearable
          onReferrerChange={(item) => {
            if (item) {
              setReferrer(item);
            } else {
              setReferrer({ id: null, name: "" });
            }
          }}
          referrerId={referrer?.id}
          useSettings
          width="264px"
        />
        {showExtraReferrer && (
          <ReferrerCreateSelect
            isClearable
            label="Extra Referrer"
            onReferrerChange={(item) => {
              if (item) {
                setExtraReferrer({ name: item.referrer, id: item.id });
              } else {
                setExtraReferrer({ name: "", id: null });
              }
            }}
            referrerId={extraReferrer?.id}
            useSettings
            width="264px"
          />
        )}
      </Box>
    </Panel>
  );
};

export default LabRecordReferrerUpdatePanel;
